<style lang="scss">
.getmore-left {
  display: none;
}
@keyframes showInLeft {
  0% {
    opacity: 0;
    transform: translateX(-1rem);
  }
  100% {
    opacity: 1;
    transform: translateX(0);
  }
}

@keyframes fadeInLeft {
  0% {
    opacity: 1;
    transform: translateX(0);
  }
  100% {
    opacity: 0;
    transform: translateX(-1rem);
  }
}

@media screen and (min-width: 55rem) {
  .getmore {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    width: 12rem;

    .getmore-button {
      width: 10rem;
      height: 3.2rem;
      background-color: transparent;
      border-radius: 1.8rem;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
      border: 0.1rem solid #fff;
      .getmore-title {
        font-family: "PingFang SC", "Microsoft YaHei";
        color: #fff;
        font-size: 1.4rem;
      }
      &:hover {
        width: 12rem;
        cursor: pointer;
        transition: all 0.2s;

        .getmore-left {
          animation: showInLeft 1s 1;
          display: inline-block;
          font-family: "PingFang SC", "Microsoft YaHei";
          color: #000000;
          color: #fff;
          font-size: 1.6rem;
          margin-left: 1rem;
        }
      }
    }
  }
}

@media screen and (max-width: 55rem) {
  .getmore {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    width: 8rem;

    .getmore-button {
      width: 6rem;
      height: 2.4rem;
      background-color: transparent;
      border-radius: 1.8rem;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
      border: 0.1rem solid #fff;
      .getmore-title {
        font-family: "PingFang SC", "Microsoft YaHei";
        color: #fff;
        font-size: 0.8rem;
      }
      &:hover {
        width: 8rem;
        cursor: pointer;
        transition: all 0.2s;

        .getmore-left {
          animation: showInLeft 1s 1;
          display: inline-block;
          font-family: "PingFang SC", "Microsoft YaHei";
          color: #000000;
          color: #fff;
          font-size: 0.8rem;
          margin-left: 1rem;
        }
      }
    }
  }
}
</style>

<template>
  <div class="getmore">
    <div class="getmore-button">
      <!-- <div class="getmore-title">
        了解更多
      </div> -->
      <div class="getmore-title">
        了解更多<span class="getmore-left">></span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "getMore",
  components: {},
  data() {
    return {};
  },
  mounted() {},
  methods: {},
};
</script>
